module.exports = __webpack_public_path__ + "MySelfCarePlan-cacfaaaf1af2d3909d683a00a021a035.png";